import { render, staticRenderFns } from "./co-applicants.vue?vue&type=template&id=d772e4de"
import script from "./co-applicants.vue?vue&type=script&lang=js"
export * from "./co-applicants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports